import { initialState } from '../initial-state';

export function reset() {
  return initialState();
}
